module.exports = __webpack_public_path__ + "media/stylesheets/images/mattrz_lp/logos/logo-07-62abf7144a7f4a2e1da0d5bab3fb8098.png";